import React from "react";
import styles from "./SelectV2.module.css";

function Select(props) {
  let disabled = props.disabled || false;
  let style = props.style || {};

  // props.placeholder ไว้ใส่รายละเอียด option แรก
  // props.setValue ไว้ดึงค่า และ ส่งค่า ไปที่ component เรียกใช้
  // props.value ไว้ดึงค่า และส่งค่าไปที่ component เพื่อใช้ เอา key or id
  // props.list  เป็นข้อมูล array ไว้ ดูรายละเอียด  ตอนเรียก

  return (
    <div className="w-full">
      <select
        style={style}
        disabled={props.disabled === "true" && disabled}
        className={`${styles.select} ${
          props.validate && !props.value ? styles.select_validator : ""
        } ${props.disabled === "true" ? styles.disabled : ""} ${
          props.value ? styles.black : styles.gray
        } w-auto`}
        value={props.value}
        onChange={(e) => {
          props.setValue(e.target.value);
        }}
      >
        { 
          props.placeholder ?         
            <option value="">
              {props.placeholder}
            </option> 
          : null 
        }
        {props.list?.map((item, idx) => {
          return (
            <option key={idx} style={{ color: "black" }} value={item["value"]}>
              {item["name"]}
            </option>
          );
        })}
      </select>
    </div>
  );
}

export default Select;
